export async function getJobs(boardToken) {
  const res = await fetch(`https://boards-api.greenhouse.io/v1/boards/${boardToken}/jobs?content=true`);
  return (await res.json()).jobs;
}

export async function getDepartments(boardToken) {
  const res = await fetch(`https://boards-api.greenhouse.io/v1/boards/${boardToken}/departments?render_as=tree`);
  return (await res.json()).departments;
}
